import React, { Component } from "react";
import Button from 'react-bootstrap/Button';
import Container from 'react-bootstrap/Container';
import Image from 'react-bootstrap/Image';
import Form from 'react-bootstrap/Form';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import NavDropdown from 'react-bootstrap/NavDropdown';
import Badge from 'react-bootstrap/Badge';

export default class Navbars extends Component {
    render() {
        return (
            <Navbar expand="lg" className="bg-body-tertiary" bg="dark" data-bs-theme="light">
                <Container fluid>
                    <Navbar.Brand href="/"><Image src="/logo.jpg" alt="Bootstrap" width="30" height="24"/>松杏茗品</Navbar.Brand>
                    <Navbar.Toggle aria-controls="navbarScroll" />
                    <Navbar.Collapse id="navbarScroll">
                    <Nav
                        
                        className="me-auto my-2 my-lg-0"
                        style={{ maxHeight: '100px' }}
                        navbarScroll
                    >
                        <Nav.Link href="/#12">推荐</Nav.Link>
                        <Nav.Link href="/newtea">春茶上市<Badge pill bg="success">新</Badge></Nav.Link>
                        <NavDropdown title="买茶" id="navbarScrollingDropdown">
                        <NavDropdown.Item href="#green">绿茶</NavDropdown.Item>
                        <NavDropdown.Item href="#moli">茉莉花茶</NavDropdown.Item>

                        <NavDropdown.Divider />
                        <NavDropdown.Item href="#red">
                            红茶
                        </NavDropdown.Item>
                        <NavDropdown.Divider />
                        <NavDropdown.Item href="#ytea">黄茶</NavDropdown.Item>
                        <NavDropdown.Divider />
                        <NavDropdown.Item href="#olong">乌龙茶</NavDropdown.Item>
                        <NavDropdown.Divider />
                        <NavDropdown.Item href="#white">白茶</NavDropdown.Item>                        
                        </NavDropdown>

                        <NavDropdown title="茶具" id="navbarScrollingDropdown">
                        <NavDropdown.Item href="#zisha">盖碗</NavDropdown.Item>
                        <NavDropdown.Item href="#china">茶壶</NavDropdown.Item>
                        <NavDropdown.Item href="#glass">茶叶罐</NavDropdown.Item>
                        

                        <NavDropdown.Divider />
                        <NavDropdown.Item href="#glass">茶刀</NavDropdown.Item>
                        <NavDropdown.Item href="#glass">茶荷</NavDropdown.Item>
                        <NavDropdown.Item href="#glass">公道杯</NavDropdown.Item>
                        <NavDropdown.Item href="#glass">茶滤</NavDropdown.Item>
                        <NavDropdown.Item href="#glass">品茗杯</NavDropdown.Item>

                        <NavDropdown.Item href="#glass">闻香杯</NavDropdown.Item>
                        <NavDropdown.Divider />
                        <NavDropdown.Item href="#teastation">茶则、茶拨、茶漏</NavDropdown.Item>
                        <NavDropdown.Item href="#olong">茶针、茶夹、茶筒</NavDropdown.Item>
                        <NavDropdown.Divider />
                        </NavDropdown>                       


                        <Nav.Link href="#" disabled>
                        下架
                        </Nav.Link>
                        <Nav.Link href="/contact">关于我们</Nav.Link>
                    </Nav>
                    <Form className="d-flex">
                        <Form.Control
                        type="search"
                        placeholder="Search"
                        className="me-2"
                        aria-label="Search"
                        />
                        <Button variant="outline-success">Search</Button>
                    </Form>
                    </Navbar.Collapse>
                </Container>
            </Navbar>
        )
    }
}